import { ConfigProvider } from 'antd';
import ukUA from 'antd/locale/uk_UA';
import { PropsWithChildren, useEffect, type JSX } from 'react';

import { stylesColorConfig } from './colors';
import { antdTheme } from './theme';

export const AntdConfigProvider = <T,>({ children }: PropsWithChildren<T>): JSX.Element => {
  useEffect(() => {
    // injecting global CSS into CSSDOM
    Object.entries(stylesColorConfig).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--${key}`, value);
    });
  }, []);

  return (
    <ConfigProvider locale={ukUA} datePicker={{ className: 'ant-date-picker' }} theme={antdTheme}>
      {children}
    </ConfigProvider>
  );
};
